import type { MethodStep } from './schema'

/** How a job runs: the three tiers, in order. */
export const method = {
  eyebrow: 'How I work',
  title: 'Audit. Build. Run.',
  summary: 'Every build is tested end to end and documented, so it never depends on one person’s memory.',
  steps: [
    { name: 'Audit', body: 'A call to look at your HighLevel account, what is broken and what you want it to do.', inputs: ['Discovery call', 'Account review', 'Goals'] },
    { name: 'Build', body: 'I set up the CRM, workflows, funnels and AI, and test every path before it goes live.', inputs: ['CRM', 'Workflows', 'Voice AI', 'Funnels'] },
    { name: 'Run', body: 'A clean handover with documentation, then ongoing support so it keeps working.', inputs: ['Docs', 'Onboarding', 'Support'] },
  ] satisfies MethodStep[],
}
